import { Element, RouterLink } from '@zmedia/bm-soccer-ui/components';
import React, { memo } from 'react';
import styles from './style.module.scss';

export function Content500() {
    return (
        <Element className={styles['content-500']}>
            <Element className={styles['container']}>
                <Element>
                    Trang web luôn luôn được nâng cấp hàng ngày hàng giờ để phục
                    vụ yêu cầu của bạn, do vậy có thể bạn đã không may mắn truy
                    cập vào đúng lúc chúng tôi đang thực hiện công việc này.
                </Element>
                <Element>
                    Hãy thư giãn và thử lại sau một thời gian ngắn, bạn sẽ lại
                    có thể tiếp tục đọc tin.
                </Element>
                <Element>
                    Để thử lại, xin hãy bắt đầu bằng cách click vào{' '}
                </Element>
                <RouterLink
                    to="/bong-da.epi"
                    className={styles['link']}
                    title="Trang chủ"
                >
                    Trang chủ
                </RouterLink>
            </Element>
        </Element>
    );
}

export default memo(Content500);
